<template>
  <!-- 银行转账 -->
  <div class="container">
    <div class="one">
      <Title-b :title="$t('Side.banktransfer')" />
      <!-- <p class="p">银行转账</p> -->
      <!-- 银行卡 -->
      <!-- <div style="width: 100%; background: #fff">
        <p
          style="color: red; font-weight: bold; text-align: center;margin: 0;padding: 20px 0; font-size: 20px;">
          {{$t("syczssd")}}{{$t("syczssds")}}
        </p>
      </div> -->
      <div class="bankcard">
        <div v-for="(item, index) in list" :key="index" class="bank-item">
          <div class="bank_block">{{ $t("Bankaccount") }}：{{ item.AccountNumber }}</div>
          <div class="bank_block">{{ $t("Bankname") }}：{{ item.BankName }}</div>
          <div class="bank_block">{{ $t("Accountholder") }}：{{ item.HolderName }}</div>
           <div class="bank_block">{{ $t("bbbbberer") }}：{{ item.Currency ? item.Currency:"无" }}</div>
          <div class="bank_block">{{ $t("ExchangeRate") }}：{{ item.ExchangeRate }}</div>
          <div>
            <Button-b :value="$t('Transferdeclaration')" @click.native="changeBank(item)"/>
          </div>
        </div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="tow" v-if="isShow">
      <Title-b :title="$t('Registertransferinformation')" />
     <img
        :src="src2"
        alt=""
        style="width: 200px; float: left; margin-top: 10px"
      />
      <div class="from">
        <div style="position: relative; left: 12px">
          <span class="span">{{ $t("Bankname") }}：</span>
          <input type="text" class="input" v-model="bankName" disabled />
        </div>
        <!-- <div>
          <span class="span">{{ $t("Transactionnumber") }}：</span>
          <input type="text" class="input" v-model="TransactionNo"  :disabled='flage'/>
        </div> -->
        <div>
          <span class="span">{{ $t("Nameofpayer") }}：</span>
          <input type="text" class="input" v-model="Contacts" />
        </div>
        <div>
          <span class="span">{{ $t("telephonenumber") }}：</span>
          <input
            type="text"
            class="input"
            v-model="PhoneNo"
            oninput="value=value.replace(/\s+/g,'')"
          />
        </div>
        <div class="From_block" style=" display: flex;flex-direction: column;">
          <!-- {{ $t("CsMoney") }}： -->
          <div  class="no">
               <!-- <span class="span">{{$t("qsrje")}}：{{sunme}}</span>
          <input type="number" name="" id="" class="input" v-model="Money" :placeholder="$t('qsrje')">
          </div> -->
          <span class="span" style="margin-left: 23px;"> {{$t('amountInput')}}：</span>
          <input type="number" :placeholder="$t('Pleaseentertheamount')" v-model="Money" style="width: 200px;height: 26px;border-radius: 5px;border: 1px solid #ccc;margin:0" :disabled="Mflag"/>
          <span class="span">RM</span>
          <div class="Rmb_absloute">{{Bizhong}}:{{ parseFloat(Money * huilv).toFixed(2)}}</div>
        </div>
          <!-- <RadioGroup v-model="Money">
            <Radio label="100" Money class="Block_button">100$</Radio>
            <Radio label="200" Money class="Block_button">200$</Radio>
            <Radio label="300" Money class="Block_button">300$</Radio>
            <Radio label="500" Money class="Block_button">500$</Radio>
            <Radio label="1000" Money class="Block_button">1000$</Radio>
          </RadioGroup> -->
          <!-- <div class="Block_button">100</div>
          <div class="Block_button">200</div>
          <div class="Block_button">300</div>
          <div class="Block_button">500</div>
          <div class="Block_button">1000</div> -->
          <!-- <input type="text" class="input" v-model="Money" /> -->
        </div>
        <div class="display-row">
          <span class="span">{{ $t("Paymentvoucherdiagram") }}：</span>
          <Upload
            multiple
            ref="upload"
            :before-upload="handleUpload"
            :show-upload-list="false"
            :on-success="handleSuccess"
            action="https://api.best-muster.com/Website/uploadImg"
          >
            <!-- action="http://8.210.215.150:8881/Website/uploadImg" -->

            <Button icon="ios-cloud-upload-outline">{{ $t("Uploadpictures") }}</Button>
          </Upload>
          <img v-if="src" class="upImg" :src="src" alt="" />
        </div>
        <div class="subimt">
          <button type="button" @click="addTransactionLog()">
            {{ $t("Confirmsubmission") }}
          </button>
        </div>
      </div>
    </div>
    <div class="three">
      <Title-b :title="$t('Personal.Transferrecords')" />
      <div class="date">
        <table id="table" cellspacing="0" v-if="isShowTable">
          <tr>
            <td>{{ $t("Personal.Tradinghours") }}</td>
            <td>{{ $t("Personal.Transactionamount") }}</td>
            <td>{{ $t("Personal.drawee") }}</td>
            <td>{{ $t("Personal.Transactionserialnumber") }}</td>
            <td>{{ $t("Personal.Receivingbankcardnumber") }}</td>
            <td>{{ $t("Personal.Auditstatus") }}</td>
            <td>{{ $t("BZ") }}</td>
          </tr>
          <tr v-for="(v, n) in allorder.TransactionInfo" :key="n">
            <td>{{ v.TransactionTime }}</td>
            <td>{{ v.Money }}</td>
            <td>{{ v.Contacts }}</td>
            <td>{{ v.TransactionNo }}</td>
            <td>{{ v.BankNo }}</td>
            <td>{{ v.AudtingDescription }}</td>
            <td>{{ v.Remark }}</td>
          </tr>
        </table>
      </div>
      <div style="margin: 10px 0 0 340px">
        <Page
          :total="dataCount"
          :page-size="pageSize"
          show-total
          @on-change="changepage"
          show-elevator
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [],
      bankName: "",
      isShow: false,
      imgName: "",
      visible: false,
      src2:'',
      src: "",
      img: "",
      allorder: [],
      addorder: [],
      TransactionNo: "",
      PhoneNo: "",
      Contacts: "",
      Money: "",
      tempObj: {},
      dataCount: 0,
      pageSize: 8,
      isShowTable: true,
      Bizhong:"RMB",
      huilv:1,
      sunme:"",
      flage:false,//禁止输入单号
      Mflag:false,//禁止输入金额
      OriginalMoney:'',
    };
  },

  methods: {
    changeinput(){
      var asdsa = this.Money / this.huilv
      this.sunme = parseFloat(asdsa).toFixed(2)
      parseFloat(this.Money /this.huilv).toFixed(2)
    },
    //插入银行卡交易记录
    async addTransactionLog() {
      // if (this.TransactionNo == "") {
      //   this.$Message.error("交易號不能為空！");
      //   return false;
      // } else 
      if (this.Contacts == "") {
        this.$Message.error("姓名不能為空！");
        return false;
      } else if (this.PhoneNo == "") {
        this.$Message.error("電話不能為空！");
        return false;
      } else if (this.Money == "") {
        this.$Message.error("付款金額不能為空！");
        return false;
      } else {
        // for (var i = 0; i < this.list.length; i++) {
        //   this.tempObj = this.list[i].AccountNumber;
        // }
        const today = new Date();
        const params = {
          UserID: localStorage.getItem("userID"),
          UserName: localStorage.getItem("name"),
          BankNo: this.tempObj,
          TransactionNo: this.TransactionNo,
          PhoneNo: this.PhoneNo,
          Money: this.Money,
          OriginalMoney :parseFloat(this.Money * this.huilv).toFixed(2),
          Contacts: this.Contacts,
          TransactionTime: today,
          Url: this.src,
        };
        const { data } = await this.$post("AddTransactionLog", params);
        if (data.State) {
          this.$Message.success("添加成功！");
          this.addorder = JSON.parse(data.ReturnJson);
          this.queryTransactionLog();
        }else{
          this.$Message.error(data.MsgText);
        }
      }
    },
    // 获取转账记录
    async queryTransactionLog(page = 1) {
      this.isShowTable = false;
      const params = {
        MemberID: localStorage.getItem("userID"),
        offset: page,
        limit: this.pageSize,
      };
      const { data } = await this.$post("QueryTransactionLog", params);
      if (data.State) {
        this.allorder = JSON.parse(data.ReturnJson);
        this.dataCount = this.allorder.TransactionInfo.length;
        this.isShowTable = true;
      }
    },
    changepage(index) {
      this.queryTransactionLog(index);
    },
    // 获取店铺银行卡信息接口
    async getShopBankInfo() {
      var JsonData = {
        ShopID: localStorage.getItem("CusID"),
      };
      const { data } = await this.$post("GetShopBankInfoNew", JsonData);
      if (data.State) {
        this.list = JSON.parse(data.ReturnJson).BankNoInfo;
        this.changeBank(this.list[0])
      }
    },
    changeBank(item) {
      this.bankName = item.BankName;
      this.tempObj = item.AccountNumber
      this.isShow = true;
      let url = "http://bsyj.51wkd.com";
      this.src2 = url + item.ImgUrl;
      this.Bizhong = item.Currency
      this.huilv = item.ExchangeRate
      // this.sunme = ""
    },
    handleView(name) {
      this.imgName = name;
      this.visible = true;
    },
    handleRemove(file) {
      // 从 upload 实例删除数据
      const fileList = this.$refs.upload.fileList;
      this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
    },
    handleUpload(file) {
      console.log(file);
      var formDate = new FormData();
      formDate.append("file", file);
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      const url = localStorage.getItem("url");
      //   this.$http.post(url + "/uploadImg", formDate, config).then((res) => {
      //     console.log(JSON.parse(res.data.ReturnJson), "imgg");
      //     console.log(res, "res");
      //     this.src = JSON.parse(res.data.ReturnJson).Image;
      //     this.img = JSON.parse(res.data.ReturnJson).ulrImage;
      //   });
    },
    handleSuccess(res, file) {
      let data = JSON.parse(res.ReturnJson);
      this.src = data.ulrImage;
      file.name = data.Image;
    }
  },

  mounted() {
    this.getShopBankInfo();
    this.queryTransactionLog();
    if(this.$route.query.orderCode){
      this.TransactionNo = this.$route.query.orderCode
      this.Money = this.$route.query.money
      // var item = this.list[0]
      // console.log(this.list)
      // this.changeBank(item)
      this.flage=true
      this.changeinput()
      this.Mflag =true
    }else{
      this.flage=false
      this.Mflag =false
    }
  }
};
</script>
<style lang="scss" scoped>
// input[disabled]{color: #000 !important;} 
.no{margin: 0 !important;}
.Rmb_absloute{font-weight: bold;}
.container {
  width: 1069px;
 

  .one {
    width: 1069px;
    background: #fff;
    margin: 10px 0 0 0;
    border-radius: 5px;
    padding: 20px 29px;

    /deep/ .bankcard {
      display: flex;
      flex-direction: row;
      margin-top: 20px;
      .bank-item {
        // background: url('../../../assets/imgs/9f57772f74ba8532f4fecf13ea11bb5.png');
        // margin: 0 20px;
        margin: 0 6px;
        // width: 306px;
        width: 337px;
        height: 200px;
        border-radius: 5px;
        box-shadow: 5px 5px 25px rgba(0, 0, 0, 0.1);
        // padding: 20px;
        line-height: 26px;
        .bank_block {
          padding: 1px 7px;
        }
        .button-custom .ivu-btn-error {
          // padding: 0 10px ;
          margin: 0 10px !important;
        }
        .button-custom .ivu-btn-error {
          width: 90%;
        }
      }
    }
  }
  .tow {
    width: 1069px;
    height: 300px;
    background: #fff;
    margin: 10px 0 0 0;
    border-radius: 5px;
    padding: 20px 29px;
    .from {
      width: 600px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      flex-wrap: wrap;
      margin: -10px 0 0 230px;
      .From_block {
        display: flex;
        flex-direction: row;
        align-items: center;
        .Block_button {
          width: 85px;
          height: 50px;
          border-radius: 5px;
          color: #fff;
          background: #4141a0;
          display: inline-block;
          text-align: center;
          line-height: 50px;
          cursor: pointer;
        }
      }

      span {
        color: #666;
      }
      div {
        //width: 280px;
        margin: 10px 12px;
      }
      .input {
        text-indent: 10px;
        cursor: pointer;
        width: 200px;
        height: 26px;
        border-radius: 5px;
        border: 1px solid #ccc;
      }
      .subimt {
        // margin: 13px 0 0 190px;
        z-index: 999;
        button {
          width: 200px;
          height: 30px;
          @include backgroundColor($_color);
          // background: #ff0000;
          border-radius: 5px;
          border: 0px solid #fff;
          color: #fff;
          cursor: pointer;
        }
      }
    }
  }
  .three {
    width: 1069px;
    // height: 389px;
    background: #fff;
    margin: 10px 0 0 0;
    border-radius: 5px;
    padding: 20px 29px;
    .date {
      margin: 33px 0 0 30px;
      #table {
        width: 949px;
        cursor: pointer;
        tr {
          height: 40px;
        }
        tr:nth-child(1) {
          font-size: 16px;
          color: #333;
          td {
            border: 0px solid #fff;
            color: #333;
            font-size: 16px;
          }
        }
        td {
          width: 100px;
          font-size: 12px;
          text-align: center;
          border: 1px solid #ccc;
        }
        td:nth-child(1) {
          // color: #ff9900;
          font-size: 12px;
        }
        .td:nth-child(even) {
          background: #fff;
        }
        .td:nth-child(odd) {
          background: #f1f5fe;
        }
      }
    }
  }
}
.display-row {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.upImg {
  width: 50px;
  height: 50px;
}
.demo-upload-list {
  display: inline-block;
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-right: 4px;
}
.demo-upload-list img {
  width: 100%;
  height: 100%;
}
.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
}
.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}
.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}
</style>



// WEBPACK FOOTER //
// src/pages/view/user/bankTransfer.vue